export default "__VITE_ASSET__lPLlcrdW__"